import { createSelector } from 'reselect'
import { selectIsKbsLoaded } from './selectIsKbsLoaded'
import { selectIds } from './selectIds'

export const selectKnowledgeBaseTotalOrNull = createSelector(
  selectIds,
  selectIsKbsLoaded,
  (ids, isKbsLoaded) => (isKbsLoaded ? ids.length : null)
)
